// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const ChartIconGroup: MarkdocTagRegistration = {
  tag: 'chart-icon-group',
  component: 'ChartIconGroup',
  attributes: {
    description: {
      type: String,
      description:
        'A description of what the group of icons signifies. This will be shown as hover text and for accessibility but not displayed in the page content.',
      required: true,
      localizable: true,
    },
    label: {
      type: String,
      description: 'Optional label to display next to the icons in the UI',
      localizable: true,
    },
  },
};
